import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BASE_PATH } from 'constants/general'
import { useIsMobile } from 'hooks/useIsMobile';

import { decodeStorage, removeStorage } from 'functions/storageBase64';

import PagoSpeiDesktop from './Deskotp'
import PagoSpeiMovil from './Movil'


export default function PagoSpei() {

    const history = useHistory();
    const { isMobile } = useIsMobile();

    const [payCodeSuccess, setPayCodeSuccess] = useState(decodeStorage('payCodeSuccess'))
    const [payCardRelation, setPayCardRelation] = useState(decodeStorage('payCardRelation'))

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Thanks Page Credit-Page SPEI')
        window.ineum('meta', 'portal', 'Credito')

        setPayCodeSuccess( decodeStorage('payCodeSuccess') )
        setPayCardRelation( decodeStorage('payCardRelation') )
    }, [])

    const clabe = payCodeSuccess?.spei_transfer;
    const payCard = payCardRelation
    const payCode = payCodeSuccess

    const handleFinalizar = () => {
        removeStorage('payCodeSuccess')
        removeStorage('payCardRelation')
        history.replace(BASE_PATH)
    };

    useEffect(() => {
        if (payCodeSuccess) {
            setTimeout(function(){
                removeStorage('payCardRelation')
                removeStorage('payCodeSuccess')
            }, 1500)
        } else {
            history.replace(BASE_PATH)
        }
    }, [])
    
    return (
        <>
            {isMobile === 'desktop'
                ?
                    <PagoSpeiDesktop 
                        clabe={clabe}
                        payCode={payCode}
                        payCard={payCard}
                        isMobile={isMobile}
                    />
                : 
                    <PagoSpeiMovil 
                        clabe={clabe}
                        payCode={payCode}
                        payCard={payCard}
                        handleFinalizar={handleFinalizar}
                        isMobile={isMobile}
                    />
            }
        </>
    )
}